import { useState } from "react";
import { Container } from "react-bootstrap";
import { ModalCambiarPassword } from "./ModalCambiarPassword";
import { HelpInfo } from "./HelpInfo";
import { UserMenu } from "./UserMenu";
import { usePageTitle } from "../../hooks/usePageTitle";
import BackIcon from "../../assets/images/BackIcon";

export const Header = () => {
  const { title, goBack, prevPath } = usePageTitle();

  const [modalPassword, setModalPassword] = useState({
    show: false,
    iduser: null,
  });

  const handleBackClick = () => {
    // Logic to navigate back
    window.history.back();
  };

  return (
    <>
      <header>
        <Container className="justify-content-between header-container">
          <span className="header-title">
            <span
              className="header-title-group"
              onClick={goBack ? handleBackClick : null}
            >
              {goBack && <BackIcon />}
              {goBack && title ? <h1>{prevPath}</h1> : <h1>{title}</h1>}
            </span>

            {prevPath && (
              <span className="header-subtitle">
                <span
                  className="header-subtitle-prevPath"
                  onClick={handleBackClick}
                >
                  {prevPath} /
                </span>{" "}
                <span className="header-subtitle-currentPath">{title}</span>
              </span>
            )}
          </span>
          <span className="header-container">
            <HelpInfo className="col-lg-6" />
            <UserMenu />
          </span>
        </Container>
      </header>

      <ModalCambiarPassword
        show={modalPassword.show}
        onHide={() => {
          setModalPassword({ show: false });
        }}
        iduser={modalPassword.iduser}
      />
    </>
  );
};
